import React, {useCallback, useEffect, useState} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {
    addWallet,
    addWalletFailure, addWalletSuccess,
    getWalletsNetworks,
    setSettingsAddWalletModalStatus
} from "../../store/cabinet/action";

import selectArrow from '../../theme/assets/svg/lp_select_arrow.svg';
import {useTranslation} from "react-i18next";

const SettingsAddWalletModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const settingsAddWalletModalStatus = useSelector(store => store.cabinet.settingsAddWalletModalStatus);
    const walletsNetworks = useSelector(store => store.cabinet.walletsNetworks);
    const addWalletStatus = useSelector(store => store.cabinet.addWalletStatus);
    const addWalletStatusErr = useSelector(store => store.cabinet.addWalletStatusErr);

    const [currentNetworkItem, setCurrentNetworkItem] = useState(false);
    const [selectStatus, setSelectStatus] = useState(false);
    const [wallet, setWallet] = useState('');


    const closeModal = useCallback(() => {
        dispatch(setSettingsAddWalletModalStatus(false));
        setCurrentNetworkItem(false);
        setSelectStatus(false);
        setWallet('');
    }, [dispatch]);

    useEffect(() => {
        if (settingsAddWalletModalStatus){
            dispatch(getWalletsNetworks());
        }
    }, [dispatch, settingsAddWalletModalStatus]);

    useEffect(() => {
        if (settingsAddWalletModalStatus && walletsNetworks?.blockchains?.length > 0) {
            setCurrentNetworkItem(walletsNetworks.blockchains[0]);
        }
    }, [settingsAddWalletModalStatus, walletsNetworks]);

    useEffect(() => {
        if (addWalletStatus){
            closeModal();
            dispatch(addWalletSuccess(false));
        }
    }, [addWalletStatus, closeModal, dispatch]);

    return (
        <Popup
            open={settingsAddWalletModalStatus}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div/>
                    <div/>
                </div>
                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>{t('Добавить кошелек')}</div>
                    {walletsNetworks ?
                        <div className={Styles.selectWrap}>
                            <div className={Styles.selectWrapTitle}>{t('Выбор сети')}</div>
                            <div className={`${Styles.selectWrapCurrentNetworkBox} ${selectStatus ? Styles.selectWrapCurrentNetworkBoxActive : null}`} onClick={()=>{setSelectStatus(!selectStatus)}}>
                                <div className={`${Styles.selectWrapCurrentNetworkBoxArrowWrap} ${selectStatus ? Styles.selectWrapCurrentNetworkBoxArrowWrapActive : null}`}><img src={selectArrow} alt="select"/></div>
                                <div className={Styles.selectWrapCurrentNetworkBoxImgWrap}><img src={currentNetworkItem.logo} alt={currentNetworkItem.name}/></div>
                                <div className={Styles.selectWrapCurrentNetwork}>{currentNetworkItem.name} ({currentNetworkItem.code})</div>
                                <div className={`${Styles.absSelectWrap} ${selectStatus ? Styles.absSelectWrapActive : null}`}>
                                    {walletsNetworks?.blockchains?.map((item, index)=>{
                                        return (
                                            <div
                                                className={`${Styles.absSelectWrapItem} ${currentNetworkItem.id === item.id ? Styles.absSelectWrapItemActive : null}`}
                                                key={'absSelectWrapItem' + index}
                                                onClick={()=>{
                                                    setSelectStatus(false);
                                                    setCurrentNetworkItem(item);
                                                }}
                                            >
                                                <div className={`${Styles.absSelectWrapItemImgWrap}`}><img src={item.logo} alt={item.name}/></div>
                                                <div className={`${Styles.absSelectWrapItemNetwork}`}>{item.name} ({item.code})</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div> : null
                    }
                    <div className={`${Styles.inputWrap} ${addWalletStatusErr?.wallet ? Styles.inputWrapWithErr : null}`}>
                        <div className={Styles.inputTitle}>{t('Кошелек')}</div>
                        <input
                            type="text"
                            placeholder="0x127..."
                            value={wallet}
                            onChange={(e)=>{setWallet(e.target.value)}}
                            onKeyDown={(event)=>{
                                if (addWalletStatusErr?.wallet){
                                    delete addWalletStatusErr?.wallet;
                                    dispatch(addWalletFailure(addWalletStatusErr));
                                }
                            }}
                        />
                        <div className={Styles.inputErr}>{addWalletStatusErr?.wallet ? addWalletStatusErr?.wallet : ''}</div>
                    </div>
                    <div className={Styles.modalContentWrapMainBtn} onClick={()=>{dispatch(addWallet({blockchain_id: currentNetworkItem.id, wallet: wallet}))}}>{t('Добавить')}</div>
                </div>
            </div>
        </Popup>
    );
};

export default SettingsAddWalletModal;

